import React, { forwardRef, useState } from "react";
import MaterialTable from "material-table";

import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

export const CspTables = ({ csp }) => {
  const [selectedRow, setSelectedRow] = useState(null);
  console.log(csp);
  return (
    <>
      <main className="shadow border p-4 mb-5 rounded-xl bg-white">
        <div className="text-center">
          <h5 className="font-weight-bold text-capitalize mb-2 text-primary-2">
            Daily trading ideas - (Filtered by Most Premium Generated)
          </h5>

          <span className="h6 font-weight-bold text-black-50 border-bottom pb-1">
            (Excludes ETFs)
          </span>
          {/* <div className="text-black-50 mt-2">{tableTime.t}</div> */}
        </div>
        <div>
          <MaterialTable
            style={{ border: "unset", boxShadow: "unset" }}
            icons={tableIcons}
            title=""
            columns={[
              {
                title: "Ticker",
                field: "ticker",
                cellStyle: {
                  textAlign: "right",
                  transform: "translateX(-12%)",
                  fontWeight: 600,
                  color: "#999",
                },
              },
              {
                title: "Stock Price",
                field: "stock_price",
                cellStyle: {
                  textAlign: "right",
                  transform: "translateX(-12%)",
                  fontWeight: 600,
                  color: "#999",
                },
              },
              {
                title: "Potantial gain",
                field: "gain",
                cellStyle: {
                  textAlign: "right",
                  transform: "translateX(-12%)",
                  fontWeight: 600,
                  color: "red",
                },
                type:'currency',
                currencySetting:{ minimumFractionDigits: 0,
                  maximumFractionDigits: 0, },
              },

              {
                title: "Gain percentage",
                render: rowData => rowData.per + '%',
                field: "per",
                cellStyle: {
                  textAlign: "right",
                  transform: "translateX(-12%)",
                  fontWeight: 600,
                  color: "#999",
                },
                type:'numeric',
                // currencySetting:{ minimumFractionDigits: 0,
                //   maximumFractionDigits: 0, },
              },

              {
                title: "Strike",
                field: "strike",
                cellStyle: {
                  textAlign: "right",
                  transform: "translateX(-12%)",

                  fontWeight: 600,
                  color: "#999",
                },
              },
              {
                title: "Expire date",
                field: "option_date",
                cellStyle: {
                  textAlign: "right",
                  transform: "translateX(-12%)",

                  fontWeight: 600,
                  color: "#999",
                },
              },
            //   {
            //     title: "Total Premium",
            //     field: "total_premium",
            //     cellStyle: {
            //       textAlign: "right",
            //       transform: "translateX(-12%)",

            //       fontWeight: 600,
            //       color: "#999",
            //     },
            //     type:'currency',
            //     currencySetting:{ minimumFractionDigits: 0,
            //       maximumFractionDigits: 0, },
            //   },
            ]}
            data={csp.daily}
            onRowClick={(evt, selectedRow) =>
              setSelectedRow(selectedRow.tableData.id)
            }
            options={{
              search: false,
              headerStyle: {
                fontSize: 12,
                lineHeight: 1.2,
                textAlign: "right",
                fontWeight: 600,
                color: "#888",
              },
              paging: false,
              rowStyle: (rowData) => ({
                fontSize: 12,

                backgroundColor:
                  selectedRow === rowData.tableData.id ? "#EEE" : "#FFF",
              }),
            }}
          />
        </div>
      </main>
     
      {/* <div className="mb-5 mx-4 px-1">
        <div className="text-danger mb-2">
          **Buy order = % of order initiated by a buy order
        </div>
        <div>
          <span className="mr-3">
            **Example: Call with buy initiation = Bullish
          </span>
          <span>Call With sell initiation = Bearish</span>
        </div>
      </div> */}
    </>
  );
};
